export const YOUTUBE = require('./youtube3_icon.png');
export const LINKEDIN = require('./linkedin_icon.png');
export const FACEBOOK = require('./facebook_icon.png');
